import { Event } from 'microsoft-graph';
import { PreParsedEvent } from "../AppContext";
import { is_hygiene_check } from "../EventFilters";
import { endOfWeek } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { TIMEZONE } from "./constants";
import { ClinicsEnum } from './enums';

export function sanatizeDirtyClinicStringToEnum(clinicName: string | undefined| null): ClinicsEnum | undefined {
  if(clinicName===undefined || clinicName ===null){
      return undefined
  }
  const dirtyEndoStrings = ['ENDO', 'endodontic', 'endodontics'];
  const ditryCrownStrings = ['Crown', 'Same', 'CAD'];
  const dirtyOMFSStrings = ['OMFS', 'Surgery', 'OMS'];
  const dirtySTUDENTStrings = ['MAIN', 'General',"HOME", 'Generic'];
  const dirtyPROSTHStrings = ['PROSTH', 'Prosthadontics'];
  const dirtyPERIOStrings = ['PERIO', 'PERIOdontics'];

  var EndoRegex = new RegExp(dirtyEndoStrings.join("|"), "i");
  var CrownRegex = new RegExp(ditryCrownStrings.join("|"), "i");
  var OMFSRegex = new RegExp(dirtyOMFSStrings.join("|"), "i");
  var STUDENTRegex = new RegExp(dirtySTUDENTStrings.join("|"), "i");
  var PROSTHRegex = new RegExp(dirtyPROSTHStrings.join("|"), "i");
  var PERIORegex = new RegExp(dirtyPERIOStrings.join("|"), "i");


  if (EndoRegex.test(clinicName)) {
    return ClinicsEnum.ENDO
  }
  if (CrownRegex.test(clinicName)) {
    return ClinicsEnum.SAME_DAY_CROWN
  }
  if (OMFSRegex.test(clinicName)) {
    return ClinicsEnum.OMFS
  }
  if (STUDENTRegex.test(clinicName)) {
    return ClinicsEnum.HOME
  }
  if (PROSTHRegex.test(clinicName)) {
    return ClinicsEnum.PROSTH
  }
  if (PERIORegex.test(clinicName)) {
    return ClinicsEnum.PERIO
  }
  console.warn(`Unable to identify which clinic to assign: '${clinicName}'`)
  //TODO: Error handling and display?
  //For now, just avoid crashing and assume its 
  return undefined
}


export const preParseISOs = (eventsParam: Event[]): PreParsedEvent[] => {  
  return eventsParam.map(eventParam => {
    try {
      const typeOfVar = Object.prototype.toString.call(eventParam.start)
      if( typeOfVar === "[object Date]"){

      }else{
        if(typeOfVar === "[object String]"){
          //@ts-ignore
          eventParam.start = zonedTimeToUtc(eventParam.start, TIMEZONE); eventParam.end = zonedTimeToUtc(eventParam.end, TIMEZONE)
        }else if(typeOfVar === "[object Object]"){
          //@ts-ignore 
          eventParam.start = zonedTimeToUtc(eventParam.start.dateTime, TIMEZONE); eventParam.end = zonedTimeToUtc(eventParam.end.dateTime, TIMEZONE)
        }
      }
    } catch(e) {
      console.log(e);
    }
   
    if(Object.prototype.toString.call(eventParam.start) !== "[object Date]") {
      // throw Error("Pre-parsed Event Detected")
    }

    //@ts-ignore 
    if(is_hygiene_check(eventParam)){
      //@ts-ignore 
      eventParam.end = endOfWeek(eventParam.start)
    }
    // @ts-ignore
    eventParam.startDateUTCMilliseconds = eventParam.start.getTime();
    // @ts-ignore
    eventParam.endDateUTCMilliseconds = eventParam.end.getTime();
    return eventParam;
  }) as PreParsedEvent[];
}